import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/LFRREIGHTTERMINAL/general";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/freighterminaltencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/freighterminalselegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/LFRREIGHTTERMINAL/status";
import { TODIS_FORM_FIELD, TODIS_FORM_FIELD_YES_NO,TODIS_FORM_DSC} from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_GENERAL_FREIGHTERMINAL from "./form/LFRREIGHTTERMINAL/general";
import TODIS_FORM_LIVE_FUND from "./form/LFRREIGHTTERMINAL/lFundingsources";
import TODIS_TECH_DOCU from "./form/LFRREIGHTTERMINAL/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
const TODIS_FORM = ({ errors, touched, status, setFieldValue, values }) => {
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the freight terminal section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id = "perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id = "fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id = "techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )
   
    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL_FREIGHTERMINAL errors={errors} touched={touched} disabled={status} />
                        <Col lg={12}>             
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="remarks" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmDescDTO" setFieldValue={setFieldValue} values={values}/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightLivePmDescDTO.remarks" label="Remarks" name="freightLivePmDescDTO.remarks" disabled={status}/>
                            {errors.freightLivePmDescDTO && errors.freightLivePmDescDTO.remarks && touched.freightLivePmDescDTO && touched.freightLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightLivePmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmStatusDTO" setFieldValue={setFieldValue} values={values}/>
            </Tab>
            <Tab eventKey="lFund" title="Funding sources">
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmStatusDTO" setFieldValue={setFieldValue} values={values}/>
            </Tab>
            <Tab eventKey="lTechDocu" title="Technical documentation">
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmStatusDTO" setFieldValue={setFieldValue} values={values}/>
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmStatusDTO" setFieldValue={setFieldValue} values={values}/>
            </Tab>
            <Tab eventKey="elegibilityproject" title="Targeted TEN-T indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmEligiTentDTO" setFieldValue={setFieldValue} values={values}/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightLivePmEligiTentDTO.remarks" label="Remarks" name="freightLivePmEligiTentDTO.remarks" disabled={status}/>
                            {errors.freightLivePmEligiTentDTO && errors.freightLivePmEligiTentDTO.remarks && touched.freightLivePmEligiTentDTO && touched.freightLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T compliance of the related freight terminal">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmTentcompDTO" setFieldValue={setFieldValue} values={values}/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightLivePmTentcompDTO.remarks" label="Remarks" name="freightLivePmTentcompDTO.remarks" disabled={status}/>
                            {errors.freightLivePmTentcompDTO && errors.freightLivePmTentcompDTO.remarks && touched.freightLivePmTentcompDTO && touched.freightLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmPiDTO" Name1="forecastTerminalTraffic" Name2="actualTerminalTraffic" Label1="Terminal traffic - forecasted" Label2="Terminal traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightLivePmPiDTO.remarks" label="Remarks" name="freightLivePmPiDTO.remarks" disabled={status}/>
                            {errors.freightLivePmPiDTO && errors.freightLivePmPiDTO.remarks && touched.freightLivePmPiDTO && touched.freightLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> */}
            <Tab eventKey="indicators" title="Performance indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="freightLivePmIndicatorsDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightLivePmIndicatorsDTO.remarks" label="Remarks" name="freightLivePmIndicatorsDTO.remarks" disabled={status}/>
                            {errors.freightLivePmIndicatorsDTO && errors.freightLivePmIndicatorsDTO.remarks && touched.freightLivePmIndicatorsDTO && touched.freightLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}
export default TODIS_FORM;